import api from "@/services/api";

export type AssociatePremiumSignatureResponse = {
  transactionId: string;
  value: number;
  pagbank: boolean;
  partner: { name: string; document: string };
  customer: { name: string; nickname?: string; document: string };
};

class CreateAssociatePremiumSignature {
  execute = async (customerDocument: string) => {
    const response = await api().post("/associate-premium/signature", {
      customerDocument,
    });
    return response.data as AssociatePremiumSignatureResponse;
  };
}

export { CreateAssociatePremiumSignature };
